<template>
  <div class="verify-modules">
    <div class="verify-form-container">
      <h3>ورود / ثبت نام</h3>
      <div :class="{ active: isActive }" class="form">
        <div class="input-container">
          <label for="login-input">کد تایید ۴ رقمی</label>
          <input
            type="number"
            id="login-input"
            @focus="focusInput"
            @blur="unfocus"
            v-model="otp"
          />
        </div>
        <button class="login-btn" @click="verify">
          <span>بررسی کد</span>
        </button>
        <p>کد فعالسازی برای {{ getPhone }} ارسال شده. لطفا منتظر بمانید</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      isActive: false,
      otp: "",
    };
  },
  created(){
    //console.log(this.getPhone);
    var phone = this.getPhone;
    console.log("mobile: "+phone);

    if(phone === ""){
      this.$router.push("/login");
    }
  },
  computed: {
    getPhone() {
      return this.$store.state.register.mobile;
    },
  },
  methods: {
    focusInput() {
      this.isActive = true;
    },
    unfocus() {
      if (this.otp !== "") {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },

    async verify() {
      let fd = new FormData();
      fd.append("phone", this.getPhone);
      fd.append("otp", this.otp);
      const response = await this.$ApiServiceLayer.post(
        "Check_otp",
        fd
      );
      console.log(response);
      if (response.status_code === 200) {

        this.$toast.open({
          message: 'شما با موفقیت وارد شدید',
          type: 'success',
          // all of other options may go here
        });

        this.$store.commit("register/storeAccessToken", response.token);

        this.$Store.commit("login/synsLoginTempToken", response.token);
        this.$Store.commit("login/loginData", response);


        window.localStorage.setItem("token", response.token);

        this.$router.push("/profile");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.verify-modules {
  width: 100%;
  height: 100vh;
  background-image: url("~@/assets/img/bg/profile_back.jpg");
  background-repeat:no-repeat;
  background-size:cover;
  background-position:center;
  padding: 20px;

  .verify-form-container {
    width: 100%;
    padding: 20px;
    margin-top: 50px;
    background-color: #fff;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    h3 {
      font-family: "sansb";
      color: #536dfe;
    }
    .form {
      width: 100%;
      .input-container {
        width: 100%;
        border-bottom: 2px solid gray;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-top: 50px;
        input {
          width: 100%;
          border: none;
          background-color: transparent;
          transition: ease all 0.5s;

          &:focus {
            outline: none;
            border: none;
          }
        }
        label {
          color: gray;
          font-size: 22px;
          position: absolute;
          bottom: 0;
          font-family: "sans";
          transition: ease all 0.5s;
        }
      }
    }
    .active {
      width: 100%;
      .input-container {
        border-bottom: 2px solid red !important;
        label {
          color: red;
          font-size: 18px;
          top: -40px;
        }
      }
    }

    .login-btn {
      width: 100%;
      height: 40px;
      border-radius: 8px;
      background-color: #536dfe;
      margin-top: 20px;
      border: none;
      font-family: "sans";
      color: #fff;
      &:focus {
        outline: none;
      }
    }
    p {
      font-size: 12px;
      font-family: "sans";
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>
